/* Copyright (c) 2024 Xperi. All Rights Reserved. */

import { AppError } from './AppError';

export class LiveTvError extends AppError {
    private static TAG: string = 'LiveTvError';

    // TODO: title will be recosidered while error UI handling.
    protected title: string;

    // TODO: type will be recosidered while error UI handling.
    protected type: string;

    static separator: string = '-';

    public constructor(
        code: string,
        message: string,
        description: string,
        title: string,
        type: string,
    ) {
        super(code, message);
        this.description = description;
        this.title = title;
        this.type = type;
    }

    public getDescription(): string {
        return this.description;
    }

    public getTitle(): string {
        return this.title;
    }

    public getType(): string {
        return this.type;
    }
}
